import {Component, Input, OnInit} from '@angular/core';
import {RegistryService} from '../../services/registry.service';

@Component({
    selector: 'app-ad-card',
    templateUrl: './ad-card.component.html',
    styleUrls: ['./ad-card.component.css']
})
export class AdCardComponent implements OnInit {

    @Input('image-space') image_space = 4;
    @Input('image') image = "";
    @Input('bg_color') bg_color = "#fff";
    @Input('title') title = "";
    @Input('subheading') subheading = "";
    @Input('price') price ;
    @Input('link') link = "";
    final_price;
    current_currency;
    currencyChangedEvent;
    rate;

    constructor(public registry:RegistryService) {

        this.currencyChangedEvent = this.registry.CurrencyChangedEvent$.subscribe(currency => {

            this.current_currency = this.registry.current_currency;
            this.recalcPrice();

        });

    }

    ngOnInit(): void {
        this.recalcPrice();

    }

    recalcPrice() {
        let rate = this.registry.getExchangeRate()
        this.final_price = this.price * rate;
        this.rate = rate;
    }

}
